<template>
  <div class="content">
        <h1>{{this.content.title}}</h1>
        <p>{{this.content.content}}</p>
        <hr>
        <b-input v-model="answer_name" placeholder="名前を入力ください"></b-input>
        <b-input v-model="answer_title" placeholder="回答のタイトルを記入ください">タイトル</b-input>
        <b-input v-model="answer_content"></b-input>
        <b-button @click="send">送る</b-button>
        <div v-for="answer in this.answers" :key="answer.name">
            {{answer.answer_title}}
        </div>
  </div>
</template>

<script>
import firebase from '@firebase/app'
export default {
  name: 'content',
  data(){
    return{
        uid: '',
        content: '',
        answer_name: '',
        answer_title:null,
        answer_content:null,
        answers: [],
        click : false
    }
  },
  created(){
    firebase.firestore().collection('questions').doc(this.$route.params.id).get().then((doc) => {
        var data = doc.data()
        this.content = data
    }).then(()=>{
         const title = this.content.title + "｜夢占い辞典ゆめみん"
        const description = "夢占い辞典ゆめみんの" + this.content.title + 'の質問と回答画面です'
        document.title = title
        document.querySelector("meta[property='og:title']").setAttribute('content', title)
        document.querySelector("meta[name='description']").setAttribute('content', description)
        document.querySelector("meta[property='og:description']").setAttribute('content', description)
    });
    firebase.firestore().collection('questions').doc(this.$route.params.id).collection('answer').get().then((querySnapshot) => {
                querySnapshot.forEach((doc) => {
                    var data = doc.data()
                    this.answers.push(data)
                })
            }) 
    firebase.auth().signInAnonymously().catch(function(error) {
      // var errorCode = error.code;
      // var errorMessage = error.message;
      console.log(error.messsage)
    }).then(()=>{
      var self = this;
      firebase.auth().onAuthStateChanged(function(user) {
        if (user) {
          self.uid = user.uid;
        } else {
          console.log("err")
        }
      });
    });
  },
  mounted(){
  }, 
    methods:{
        send(){
            if(this.click == false){
                this.$buefy.toast.open('押しました。そのままお待ちください')
                this.click = true
                firebase.firestore().collection('user').doc().set({
                    uid: this.uid,
                }).then(()=>{
                    firebase.firestore().collection('questions').doc(this.$route.params.id).collection('answer').doc().set({
                        uid: this.uid,
                        answer_name: this.answer_name,
                        answer_title: this.answer_title,
                        answer_content: this.answer_content
                    });
                }).then(()=>{
                    this.$router.go({ name: 'content', params: { id: this.$route.params.id } })
                }); 
            }else{
                this.$buefy.toast.open('すでに送信しています')
            }       
        }
    }
}
</script>

<style scoped>
.entry{
  max-width: 520px;
  margin:auto;
  padding: 10px;
}
h1{
  font-weight: bold;
  font-size: 1.2em;
  padding:10px;
}
h3{
  font-weight: bold;
  font-size: 1.2em;
  padding:10px;
}
p{
  padding: 10px;
}
.how_to{
  padding-top: 20px;
}
</style>